import React from 'react';
import contactMap from '../../../assets/images/contact-us-map.jpg';

const ContactMap = () => {
  return (
    <div className="contact-map">
      <img src={contactMap} alt="contact-map" className="contact-map-post" />
    </div>
  );
};

export default ContactMap;
